export function flattenObject(
  obj: Record<string, unknown>,
): Record<string, unknown> {
  const value: Record<string, unknown> = {};

  const keys = Object.keys(obj);
  keys.forEach((key) => {
    if (typeof obj[key] === "object" && obj[key] !== null) {
      const flat = flattenObject(obj[key] as Record<string, unknown>);
      const nestedKeys = Object.keys(flat);
      nestedKeys.forEach((nestedKey) => {
        value[`${key}.${nestedKey}`] = flat[nestedKey];
      });
    } else {
      value[key] = obj[key];
    }
  });

  return value;
}
